module.exports = __webpack_public_path__ + "img/new-user-select.406bf927.png";